import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getProductTypeByName = (
    token: string,
    backend: string,
    productTypeName: string
) => {
    return fetch(
        `${getApiUrl(backend)}producttypes/by_name/${productTypeName}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain, */*'
            },
        }
    );
};

export default getProductTypeByName;